import { render, staticRenderFns } from "./ExternalGameTab.vue?vue&type=template&id=1136ba5f&scoped=true&lang=pug"
import script from "./ExternalGameTab.vue?vue&type=script&lang=js"
export * from "./ExternalGameTab.vue?vue&type=script&lang=js"
import style0 from "./ExternalGameTab.vue?vue&type=style&index=0&id=1136ba5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136ba5f",
  null
  
)

export default component.exports